








import Vue from "vue";
export default Vue.extend({
  mounted() {
    const activityId = "20000";
    const replyHash = location.hash.match(/^#reply(\d+)/);
    const replyId = replyHash ? +replyHash[1] : null;
    const BBComment: any = (window as any).bbComment;
    if (typeof BBComment === "function") {
      const bbcinst = new BBComment(
        ".comm",
        activityId,
        4,
        null,
        replyId && replyId > 0 ? replyId : ""
      );
      bbcinst.loadPage(0);
    }
  }
});
